import plangridTrackEvents from './amplitudeInit-vanilla';
import getPageNameFromLocation from '../../pages/helpers/getPageNameFromLocation';

export const init = () => {
  const pagename = getPageNameFromLocation(window.location.href);
  plangridTrackEvents(pagename);
  toggleActiveLink()
  addNavigationHandler()
  addCitySelectorHandler()
  addFormHandler()

  MktoForms2.loadForm("//app-ab10.marketo.com", "572-JSV-775", 1017)
  MktoForms2.loadForm("//app-ab10.marketo.com", "572-JSV-775", 1025)
}

document.addEventListener('DOMContentLoaded', init)

function toggleActiveLink() {
  let activeLink
  const path = window.location.pathname
  const navigation = document.querySelector('.user-groups .navigation')

  if (path.indexOf('faq') >= 0) {
    activeLink = navigation.querySelector('li:nth-child(3) a')
  } else if (path.indexOf('lead') >= 0) {
    activeLink = navigation.querySelector('li:nth-child(2) a')
  } else {
    activeLink = navigation.querySelector('li:nth-child(1) a')
  }

  activeLink.href = 'javascript:;'
  activeLink.classList.add('active')
  navigation.querySelector('button').innerHTML = activeLink.innerHTML
}

function addNavigationHandler() {
  const navigation = document.querySelector('.user-groups .navigation')
  const button = navigation.querySelector('button')

  button.addEventListener('click', (e) => {
    navigation.classList.toggle('open')
  }, false)

  document.body.addEventListener('click', (e) => {
    if (!navigation.contains(e.target)) {
      navigation.classList.remove('open')
    }
  }, false)
}

function addCitySelectorHandler() {
  const city = document.querySelector('.city-selection')
  if (city) {
    const input = city.querySelector('input')
    const dropdown = city.querySelector('.dropdown')
    const field = dropdown.querySelector('.value')
    const options = dropdown.querySelectorAll('.menu span')

    dropdown.addEventListener('click', (e) => {
    	dropdown.classList.toggle('open')
    }, false)

    options.forEach((option, i) => {
    	option.addEventListener('click', (e) => {
        field.innerHTML = e.target.innerHTML
        field.classList.remove('placeholder')
        if (i === options.length - 1) {
        	input.value = ''
        	city.classList.add('entry')
        } else {
          input.value = e.target.innerHTML
        	city.classList.remove('entry')
        }
      }, false)
    })

    document.body.addEventListener('click', (e) => {
      if (!dropdown.contains(e.target)) {
      	dropdown.classList.remove('open')
      }
    }, false)
  }
}

function addFormHandler() {
  const form = document.querySelector('form')

  form.addEventListener('submit', (e) => {
    e.preventDefault()
    if (form.name === 'lead-request') {
      submitLeadForm()
    } else {
      submitJoinForm()
    }
    return false
  })
}

// TODO: Look into removing Marketo library and using AJAX to call endpoint directly

function submitJoinForm() {
  const joinForm = MktoForms2.getForm(1017)
  const form = document.querySelector('.form')
  const email = document.forms['join-request'].email.value
  const emailValid = /@.*?\./.test(email)

  if (emailValid) {
    joinForm.onSuccess(function(values, followUpUrl) {
      form.classList.add('confirmation')
      return false
    })

    joinForm.setValues({
      FirstName: document.forms['join-request']['first-name'].value,
      LastName: document.forms['join-request']['last-name'].value,
      Email: email,
      pUGCity: document.forms['join-request'].city.value
    })

    joinForm.submit()
  } else {
    form.classList.add('email-error')
  }
}

function submitLeadForm() {
  const leadForm = MktoForms2.getForm(1025)
  const form = document.querySelector('.form')
  const email = document.forms['lead-request'].email.value
  const emailValid = /@.*?\./.test(email)

  if (emailValid) {
    leadForm.onSuccess(function(values, followUpUrl) {
      const form = document.querySelector('.form')
      form.classList.add('confirmation')
      return false
    })

    leadForm.setValues({
      FirstName: document.forms['lead-request']['first-name'].value,
      LastName: document.forms['lead-request']['last-name'].value,
      Email: email,
      pUGCity: document.forms['lead-request'].city.value,
      userGroupCapacity: document.forms['lead-request'].capacity.value
    })

    leadForm.submit()
  } else {
    form.classList.add('email-error')
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/userGroups.js